import { createContext } from "react";

const LeadContext = createContext({
    supplyApi: null,
});

export default LeadContext;
